import React from 'react';
import { Router, Route, Link, browserHistory } from 'react-router'
import TopPanel from "../toppanel.js";
import ReportContent from "./ReportContent.js";

module.exports = React.createClass({

    getInitialState: function() {
        return {
            report: null,
            name: ""
        };
    },

    componentDidMount: function() {
        this.mountState = true;
    },
    componentWillMount: function() {
        this.state.link = window.location.pathname.replace("/report/", "");
    },

    componentWillUnmount: function() {
        this.mountState = false;
    },

    goBack: function() {
        HC_History.replace("/reports");
    },

    gotReport: function(report) {
        this.setState({name: report.name});
    },

    render: function() {
        var licon, liconClick, liconText, showText, content, logo;

        var deviceType = HC_DeviceType();
        $('#react-content').css('width', '100%');

        if (HC_GetSession()) {
            licon = "fa-angle-left";
            liconClick = this.goBack;
            liconText = "Back";
            showText = deviceType !== HC_CONST.SCR_PHONE;
        } else {
            logo = (<a id="hc-report-logo" href="/" style={{position:"absolute", bottom:0, left:0, margin:'2rem'}} to="/">
                <img src={window.HC_SITE_LOGO.src} alt="logo" width="122" height="48" style={{marginTop:"10%", marginBottom:"2%"}}/>
            </a>);
        }

        var report = this.state.report;
        var content = (<ReportContent link={this.state.link} gotReport={this.gotReport}/>);

        return (
            <div style={{position:"absolute", top:0, bottom:0, left:0, right:0, whiteSpace: 'normal'}}>
                <TopPanel text={this.state.name} licon={licon} onLiconClick={liconClick} liconText={liconText} EnableMenuText={showText}/>
                <div style={{position:"absolute", width:"100%", top:"60px", bottom:"0",overflowX:"hidden", overflowY:"auto", WebkitOverflowScrolling:'touch'}}>
                    {content}
                </div>
                {logo}
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./reports/FullReport.js